import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditNoteLazy = React.lazy(
	() => import(/* webpackChunkName : 'EditNote' */ './components/EditNote')
);

export default (store) => {
	return {
		path: 'home/teacher-notes/edit-note/:threadId',
		element: <AsyncLoading component={<EditNoteLazy />} />,
	};
};
